module.exports = __webpack_public_path__ + "img/north-yorkshire.2.a884879.jpg";